import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { User } from '@app/_models';
import { MatDialog } from '@angular/material/dialog';
import { CommonUtility } from '@app/_modules/commonUtility';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class PaymentService {
    private userSubject: BehaviorSubject<User>;
    public user: Observable<User>;
    Base_url;
    commonUtility:CommonUtility;
    isgPay_url;
    constructor(
        private router: Router,
        private http: HttpClient,
        private snackBar: MatSnackBar,
    ) {
      this.Base_url = environment.Base_url;
      this.isgPay_url =environment.isgPayUrl;
      this.commonUtility = new CommonUtility(snackBar);
    }
    // fetchBySjRegistrationNo(req){
    //   let headers = new HttpHeaders({
    //     'Content-Type' : 'application/json',
    //   });
    //   let url = `${this.Base_url}cessservice/fetchBySjRegistrationNo`;
    //   return this.http.post<any>(url,req,{
    //     headers : headers,
    //     observe:'response'
    //   })
    // }
    
    submitXavierDetails(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}cessservice/submitXavierDetails`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }

    captureXavierResponse(req){
      let headers = new HttpHeaders({
        'Content-Type' : 'application/json',
      });
      let url = `${this.Base_url}cessservice/captureXavierResponse`;
      return this.http.post<any>(url,req,{
        headers : headers,
        observe:'response'
      })
    }
    downloadXavierTxnReceipt(req)
    {  let headers = new HttpHeaders( {
      'Content-Type': 'application/json',
      'Accept': 'application/octet-stream',
      'timeout':  `${999999}`
  });
    let url = `${this.Base_url}cessservice/downloadXavierTxnReceipt`;
    return this.http.post(url,req,
      { headers,responseType: 'blob',
      reportProgress: true,
      observe: 'response',       }
    );
  }


}
